export const LABEL_SOLD_BY = 'Vendido por:';
export const LABEL_TIME_SLOT_QUESTION = '¿En qué horario?';
export const LABEL_SHIPPED_BY = 'Enviada por';
export const LABEL_RECEIVE_TODAY = 'Recibe hoy: ';
export const LABEL_RECEIVE_TOMORROW = 'Recibe mañana: ';
export const LABEL_RECEIVE_BETWEEN = 'Recibe entre: ';
export const LABEL_RECEIVE_ON = 'Recibe el: ';
export const LABEL_PICKUP_FROM = 'Retira desde:';
export const LABEL_CHANGE_STORE = 'Elegir otra tienda Cencosud';
export const LABEL_CHANGE_COPEC = 'Elegir otro punto Blue Express y Copec';
export const LABEL_DELIVERY_HOURS_AM_TO_PM = 'Entre 09:00 y 21:00';
export const LABEL_DELIVERY_HOURS_PM = 'Entre 12:00 y 21:00';

export const ICON_PARIS = 'il-paris';
export const ICON_STORE = 'il-store';
export const ICON_PRODUCT = 'il-product';

export const BRAND_PARIS = 'paris';
export const BRAND_JUMBO = 'jumbo';
export const BRAND_EASY = 'easy';
export const BRAND_COPEC = 'copec';
export const BRAND_SANTA_ISABEL = 'sisa';

export const DEFAULT_ORIGIN_NODE_TYPE = 'PROVIDER';
export const DEFAULT_SHIPPING_SUB_TYPE = 'HOME';
